var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mx-0 px-3",attrs:{"fluid":""}},[_c('v-card',{staticClass:"avsb-card-background",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"pl-1 py-2"},[_vm._v("Tasks")])],1),_c('TableTasks'),_c('DialogTaskCreate')],1)}
var staticRenderFns = []

export { render, staticRenderFns }